import type { InjectionKey } from "vue";

export interface LayoutContext {
  hideMenuItems: boolean;
  set: (opts: Partial<LayoutContext>) => void;
}

export const LayoutKey: InjectionKey<LayoutContext> = Symbol("layout");
